import { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Box from "@mui/material/Box";
import MpgInput from "../../../../../CommonFormComp/MpgInput";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useGetLoggedInUserDetails } from "../../../../../hooksAndFunctions/customHooks/useGetLoggedInUserDetails";
import FormHelperText from '@mui/material/FormHelperText';
import sortBy from "lodash/sortBy";
import { useOutletContext } from 'react-router-dom';

const EditSubFolderActionDialog = ({ open, setOpen, parentItemObjData, setParentItemObjData, targetItemObjData, setTargetItemObjData, compositeFolderArrayInsideRoot, setCompositeFolderArrayInsideRoot }) => {

    const { loggedInUser } = useGetLoggedInUserDetails();
    const { emailAddress } = loggedInUser;

    // console.log("compositeFolderArrayInsideRoot-parentItemObjData11111:", parentItemObjData)

    /**
     * parentItemObjData gives complete folder data object for computation
     */

    useEffect(() => {
        if (!!open) {
            setOpen(true)
        } else {
            setOpen(false)
        }
    }, [open])

    const handleClose = (event, reason) => {
        if (reason && reason == "backdropClick") {
            return '';
        } else {
            setOpen(false);
        }
        setParentItemObjData({})
        setTargetItemObjData({})
    };

    const schema = yup.object().shape({
        sub_folder_name: yup.string().label('This field').required().max(50),
    });

    const rhfFormInstanceForPDSubFolderEdit = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            folder_name: "",
            sub_folder_name: "",
        },
    });

    const { setValue, reset, watch } = rhfFormInstanceForPDSubFolderEdit

    const inputSubFolderName = watch('sub_folder_name')
    /** populate folder name in the form */
    useEffect(() => {
        if (!!parentItemObjData) {
            setValue("folder_name", parentItemObjData?.ResourceFolderName)
            setValue("sub_folder_name", targetItemObjData?.ResourceSubFolderName)
        }
    }, [parentItemObjData, targetItemObjData])

    /**sub folder name validation */

    /**sub folder name validation. at same level same name is not allowed. */
    let arrayOfOnlySubFolderNames = []

    /**subfolder count validation. max 20 subfolders are allowed to create at each folder level. */
    const subFolderList = parentItemObjData?.ResourceSubFolders || []

    let subFolders = !!subFolderList && subFolderList.filter((eachSubFolder) => {
        if (eachSubFolder?.Id !== targetItemObjData?.Id) {
            if (!eachSubFolder?.IsDeleted) {
                arrayOfOnlySubFolderNames.push(eachSubFolder?.ResourceSubFolderName)
                return eachSubFolder?.Id
            }
        }
    })

    const [errorMsg, setErrorMsg] = useState("")
    useEffect(() => {
        /**subFolders name validation. at same level same name is not allowed. */
        if (!!arrayOfOnlySubFolderNames.includes(inputSubFolderName?.trim())) {
            const foldersNameMsg = "This subfolder name exists at this level."
            setErrorMsg(foldersNameMsg)
        }
        /**subFolders count validation. max 20 subFolders are allowed to create for each folder. */
        else if (subFolders.length >= 20) {
            const subFoldersLimitMsg = "Max 20 subFolders could be created at this level."
            setErrorMsg(subFoldersLimitMsg)
        }
        else {
            setErrorMsg("")
        }
    }, [arrayOfOnlySubFolderNames, inputSubFolderName, subFolders])


    /**disabling submit on failing custom validations */
    const [disableSubmitButton, setDisableSubmitButton] = useState(false)
    useEffect(() => {
        if (subFolders.length >= 20) {
            setDisableSubmitButton(true)
        } else if (!!arrayOfOnlySubFolderNames.includes(inputSubFolderName?.trim())) {
            setDisableSubmitButton(true)
        } else {
            setDisableSubmitButton(false)
        }
    }, [subFolders, arrayOfOnlySubFolderNames, inputSubFolderName])

    const onSubmitForPDSubFolderEdit = (data, e) => {

        const editedSubFolderName = data?.sub_folder_name

        const subFolderArrayFromParentObj = parentItemObjData?.ResourceSubFolders

        let modifiedArray = []
        !!subFolderArrayFromParentObj && subFolderArrayFromParentObj.forEach(eachSubFolder => {
            if (eachSubFolder.Id === targetItemObjData.Id) {
                modifiedArray.push({
                    ...eachSubFolder,
                    ResourceSubFolderName: editedSubFolderName,
                    UpdatedBy: emailAddress || ""
                })
            } else {
                modifiedArray.push(eachSubFolder)
            }
        });

        const completeParentObjectWithEditedSubFolder = {
            ...parentItemObjData,
            ResourceSubFolders: modifiedArray || []
        }


        /**now add parent object in compositeFolderArrayInsideRoot at same index */

        /**index is required as we want to insert excludedItem at same index in array later. Beacause if we try to merge item into array then it creates that entry at the end of the array. To avoid this and to maintain same position, we need this index to be used in splice method */

        let indexOfExcludedTreeItem = '' /**must be in string */
        let excludedTreeItem = {}
        const arrayWithoutExcludedTreeItem = !!compositeFolderArrayInsideRoot && compositeFolderArrayInsideRoot.filter((eachItem, index) => {

            if (eachItem?.Id !== parentItemObjData?.Id) {
                return eachItem
            } else {
                indexOfExcludedTreeItem = `${index}`
                excludedTreeItem = eachItem
            }
        })


        if (!!indexOfExcludedTreeItem) {
            const index = Number(indexOfExcludedTreeItem)

            /**
             * Inserting Item at specific index in an array:
             * splice(indexWhereToInsertItem, startFromIndex, NewItemToBeInserted)
             */

            arrayWithoutExcludedTreeItem.splice(index, 0, completeParentObjectWithEditedSubFolder);

            /**as splice modifies original array itself,  arrayWithoutExcludedTreeItem after splice contains inserted completeParentObjectWithEditedSubFolder at desired index*/

            /**sort subfolder array*/
            const inputArrayForSorting = arrayWithoutExcludedTreeItem || []

            const sortedFolderArray = sortBy(inputArrayForSorting, function (item) {
                const subfolderName = item?.ResourceSubFolderName || ""
                /**we are converting all subfolder names into smallcase for proper aphabetical order */
                return [subfolderName.toLowerCase()];
            });

            setCompositeFolderArrayInsideRoot(sortedFolderArray || [])
        }

        reset({ folder_name: "", sub_folder_name: "" })

        handleClose()
    };

    const resourcesCMSData = useOutletContext();

    const fetchClientAccResDtlsLabel = (key) => {
        if (resourcesCMSData && resourcesCMSData?.pageContent["ClientAccountResourcesDetails"]) {
          const resourcesCMSDataLabel = resourcesCMSData.pageContent["ClientAccountResourcesDetails"];
          return returnLabel(resourcesCMSDataLabel?.Labels, key)
        }
    }

    const fetchCommonCMSLabel = (key) => {
        if (resourcesCMSData && resourcesCMSData?.pageContent["CommonComponent"]) {
            const commonCMSDataLabel = resourcesCMSData.pageContent["CommonComponent"];
            return returnLabel(commonCMSDataLabel?.Labels, key)
        }
        return '';
    }

    const returnLabel = (labelArray, key) => {
        if (labelArray.length > 0 && key) {
            return labelArray.find((x) => x.Key === key)?.Phrase || '';
        }
        return '';
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <Box
                component="form"
                noValidate
                autoComplete="off"
                onSubmit={(e) => {
                    /**  e.stopPropagation(); required to use form within form seperately to avoid conflicts between nested form submits. */
                    e.stopPropagation();
                    rhfFormInstanceForPDSubFolderEdit.handleSubmit(onSubmitForPDSubFolderEdit)(e)
                }}
            >
                <DialogTitle>

                    <MpgInput
                        rhfFormInstance={rhfFormInstanceForPDSubFolderEdit}
                        name={"folder_name"}
                        label={"Folder Name"}
                        fullWidth
                        disabled
                    />
                    <MpgInput
                        rhfFormInstance={rhfFormInstanceForPDSubFolderEdit}
                        name={"sub_folder_name"}
                        label={"SubFolder Name"}
                        fullWidth
                    />
                    {
                        <FormHelperText error={!!errorMsg}>
                            {errorMsg}
                        </FormHelperText>
                    }
                </DialogTitle>
                <DialogContent>

                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            handleClose()
                        }}
                    >
                        {fetchCommonCMSLabel("Common.Cancel")}
                    </Button>

                    <Button
                        type="submit"
                        disabled={!!disableSubmitButton}
                    >
                         {fetchCommonCMSLabel("Common.OK")}
                    </Button>
                </DialogActions>
            </Box>
        </Dialog>
    )
}
export default EditSubFolderActionDialog